/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listinglinkcannotbechanged4Inputs */

const en_listinglinkcannotbechanged4 = /** @type {(inputs: Listinglinkcannotbechanged4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The listing link cannot be changed after the event is created. To link to a different listing, create a new event.`)
};

const de_listinglinkcannotbechanged4 = /** @type {(inputs: Listinglinkcannotbechanged4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Verknüpfung zum Ort lässt sich nach dem Erstellen des Events nicht mehr ändern. Für einen anderen Ort erstellst du ein neues Event.`)
};

/**
* | output |
* | --- |
* | "The listing link cannot be changed after the event is created. To link to a different listing, create a new event." |
*
* @param {Listinglinkcannotbechanged4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listinglinkcannotbechanged4 = /** @type {((inputs?: Listinglinkcannotbechanged4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listinglinkcannotbechanged4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listinglinkcannotbechanged4(inputs)
	return de_listinglinkcannotbechanged4(inputs)
});
export { listinglinkcannotbechanged4 as "listingLinkCannotBeChanged" }